import React from 'react';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { COLORS } from '../constants/styles';

const MandatoryAsteriskMessage = styled.div`
    color: ${COLORS.grey7};
    font-size: 0.75rem;
    display: flex;
`;

type IFormManditoryAstrixMessageProps = React.HTMLProps<HTMLDivElement>;

export const FormManditoryAstrixMessage = ({ className }: IFormManditoryAstrixMessageProps) => {
    return (
        <MandatoryAsteriskMessage className={className}>
            {TranslationHelpers.getFormattedMessage('label.mandatory')}
        </MandatoryAsteriskMessage>
    );
};
